export function fmtCurrency(n, opts = {}) {
    if (n == null || isNaN(n)) return "—";
    const { decimals = 0 } = opts;
    return n.toLocaleString("en-US", {
        style: "currency", currency: "USD",
        minimumFractionDigits: decimals, maximumFractionDigits: decimals,
    });
}

export function fmtSigned(n, opts = {}) {
    if (n == null || isNaN(n)) return "—";
    const sign = n > 0 ? "+" : n < 0 ? "-" : "";
    return sign + fmtCurrency(Math.abs(n), opts);
}

export function fmtPct(n, opts = {}) {
    if (n == null || isNaN(n)) return "—";
    const { decimals = 2, signed = true } = opts;
    const sign = signed && n > 0 ? "+" : "";
    return `${sign}${n.toFixed(decimals)}%`;
}

export function fmtNumber(n, decimals = 2) {
    if (n == null || isNaN(n)) return "—";
    return n.toLocaleString("en-US", { minimumFractionDigits: 0, maximumFractionDigits: decimals });
}

export function fmtCompact(n) {
    if (n == null || isNaN(n)) return "—";
    if (Math.abs(n) >= 1e12) return `$${(n / 1e12).toFixed(2)}T`;
    if (Math.abs(n) >= 1e9) return `$${(n / 1e9).toFixed(2)}B`;
    if (Math.abs(n) >= 1e6) return `$${(n / 1e6).toFixed(2)}M`;
    if (Math.abs(n) >= 1e3) return `$${(n / 1e3).toFixed(1)}K`;
    return fmtCurrency(n);
}

export function fmtDate(iso) {
    if (!iso) return "—";
    const s = String(iso);
    // ISO date (optionally with time): parse the Y-M-D parts as LOCAL to avoid an
    // off-by-one day from UTC parsing, and render consistently as "Jan 6, 2024".
    const m = s.match(/^(\d{4})-(\d{2})-(\d{2})/);
    let d;
    if (m) {
        d = new Date(Number(m[1]), Number(m[2]) - 1, Number(m[3]));
    } else {
        d = new Date(s);
    }
    if (isNaN(d)) return s;
    return d.toLocaleDateString("en-US", { year: "numeric", month: "short", day: "numeric" });
}

export function gainClass(n) {
    if (n == null || n === 0) return "text-muted-foreground";
    return n > 0 ? "text-gain" : "text-loss";
}

export function fmtMetric(fmt, v) {
    if (v == null || isNaN(v)) return "—";
    if (fmt === "pct") return `${v.toFixed(2)}%`;
    if (fmt === "usd") return fmtCurrency(v, { decimals: 2 });
    if (fmt === "fx") return `₪${v.toFixed(3)}`;
    return v.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
}
